import { createTheme } from '@mui/material/styles';

const CustomTheme = createTheme({
    direction: 'rtl',
    typography: {
        // use RokhFaNum as the global font
        fontFamily: ['RokhFaNum', 'Arial', 'sans-serif'].join(','),
        allVariants: {
            fontFamily: 'RokhFaNum',
        },
    },
    // custom field if you’re using it in your own components
    bottomTab: {
        fontFamily: 'RokhFaNum',
    },
});

export default CustomTheme;
